import { useEffect, useRef } from "react"

const useMenuToggle = setShowMenu => {
  const menuRef = useRef(null)
  const languageRef = useRef(null)

  const handleToggle = menu => {
    setShowMenu(prev => (prev === menu ? null : menu))
  }

  useEffect(() => {
    const handleScroll = () => {
      setShowMenu(null)
    }

    const handleClickOutside = event => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        languageRef.current &&
        !languageRef.current.contains(event.target)
      ) {
        setShowMenu(null)
      }
    }

    window.addEventListener("scroll", handleScroll)
    window.addEventListener("click", handleClickOutside)

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("click", handleClickOutside)
    }
  }, [])

  return { handleToggle, menuRef, languageRef }
}

export default useMenuToggle
